import { StayInformedService } from 'src/app/shared/service/stay-informed.service';
import { PATH_ROUTING } from './../../../../../../shared/enums/routing-enums';
import { ActivatedRoute, Router } from '@angular/router';
import { Spinner } from './../../../../../../core/services/spinner.service';
import { CustomValidator } from 'src/app/shared/directive/custom-validator';
import { ToastrService } from 'ngx-toastr';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Component, OnInit, ViewChild } from '@angular/core';
import { UploadFile } from 'src/app/shared/model/file.model';
import { MESSAGE_TOAST } from 'src/app/shared/enums/message-toast-enum';
import { TYPE } from 'src/app/shared/enums/admin-enum';

@Component({
  selector: 'app-create-edit-stay-informed',
  templateUrl: './create-edit-stay-informed.component.html',
  styleUrls: ['./create-edit-stay-informed.component.scss']
})
export class CreateEditStayInformedComponent implements OnInit {


  @ViewChild('fileInput') fileInput;
  isEditMode = false;
  formGroup: FormGroup;
  docFile;
  id: number;

  constructor(
    private toastr: ToastrService,
    private spinner: Spinner,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private stayInformedService: StayInformedService
  ) { }

  ngOnInit() {
    this.initForm();
    this.activatedRoute.params.subscribe(param => {
      if (param.id) {
        this.isEditMode = true;
        this.id = param.id;
        this.getStayInformedById(this.id);
      }
    });
  }

  public save() {
    if (!this.formGroup.valid) {
      this.markFormGroupTouched(this.formGroup);
      return;
    }
    const model = {
      name: this.formGroup.controls.name.value,
      type: this.formGroup.controls.type.value,
      url: this.formGroup.controls.type.value === TYPE.LINK ? this.formGroup.controls.url.value : null,
      resource: this.formGroup.controls.type.value === TYPE.FILE ? this.formGroup.controls.resource.value : null,
    };
    this.spinner.show();
    if (!this.isEditMode) {
      this.stayInformedService.addStayInformed(model).subscribe((res: any) => {
        this.spinner.hide();
        if (res.success) {
          this.toastr.success(MESSAGE_TOAST.ADD_STAY_INFORMED);
          this.router.navigate([PATH_ROUTING.PATH_SRM, PATH_ROUTING.PATH_ADMIN, PATH_ROUTING.PATH_STAY_INFORMED_ADMIN]);
        }
      });
    } else {
      this.stayInformedService.updateStayInformed(model, this.id).subscribe((res: any) => {
        this.spinner.hide();
        if (res.success) {
          this.toastr.success(MESSAGE_TOAST.EDIT_STAY_INFORMED);
          this.router.navigate([PATH_ROUTING.PATH_SRM, PATH_ROUTING.PATH_ADMIN, PATH_ROUTING.PATH_STAY_INFORMED_ADMIN]);
        }
      });
    }
  }

  private getStayInformedById(id) {
    this.spinner.show();
    this.stayInformedService.getStayInformedById(id).subscribe(res => {
      this.spinner.hide();
      if (res.data) {
        this.initForm(res.data);
      }
    });
  }

  private initForm(model?) {
    if (model) {
      this.formGroup = new FormGroup({
        name: new FormControl(model.name),
        type: new FormControl(model.type),
        url: new FormControl(model.url, [CustomValidator.url]),
        resource: new FormControl(model.resource),
      });
    } else {
      this.formGroup = new FormGroup({
        name: new FormControl(''),
        type: new FormControl(TYPE.LINK),
        url: new FormControl('', [CustomValidator.url]),
        resource: new FormControl(''),
      });
    }
  }

  public selectionChange() {
    if (this.formGroup.controls.type.value === TYPE.LINK) {
      this.formGroup.controls.resource.clearValidators();
      this.formGroup.controls.url.setValidators([CustomValidator.required, CustomValidator.url]);
    } else {
      this.formGroup.controls.url.clearValidators();
      this.formGroup.controls.resource.setValidators(CustomValidator.required);
    }
    this.formGroup.controls.url.updateValueAndValidity();
    this.formGroup.controls.resource.updateValueAndValidity();
  }

  public onFileInput(event) {
    const fileTypes = ['png', 'jpg', 'jpeg', 'pdf', 'doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx'];
    const file = event.target.files[0];
    const uploadFile = new UploadFile(file, false);
    if (uploadFile.file.size > 10485760) {
      this.toastr.error(
        MESSAGE_TOAST.ERROR_CHOOSE_FILE_DOC_SIZE
      );
    } else if (fileTypes.filter(item => item === uploadFile.type).length === 0) {
      this.toastr.error(
        MESSAGE_TOAST.ERROR_CHOOSE_FILE_DOC
      );
    } else {
      this.removeAttachment();
      this.formGroup.controls.resource.setValue(file);
      this.formGroup.controls.url.setValue('');
    }
  }

  public removeAttachment() {
    this.formGroup.controls.resource.setValue(null);
    this.fileInput.nativeElement.value = '';
  }

  private markFormGroupTouched(formGroup: FormGroup): void {
    (Object as any).values(formGroup.controls).forEach(control => {
      control.markAsTouched();
      if (control.controls) {
        this.markFormGroupTouched(control);
      }
    });
  }

}
